import http from "../helpers/http-common";
import { ICrmbLeadArquivoCleanDTO, ICrmbLeadArquivoDTO, ICrmbLeadArquivoFullDTO } from "../models/happy-code-api.model";
import { baseCreate } from "./base/base-create.service";
import { baseDelete } from "./base/base-delete.service";
import { baseFindList } from "./base/base-find-list.service";
import { baseFind } from "./base/base-find.service";
import { baseUpdate } from "./base/base-update.service";

export const useLeadArquivoService = () => {

  const resourceURL = 'crmb/lead-arquivo';


  const download = (fileName: string, name: string) => {
    return http.get(`${resourceURL}/download/${fileName}?name=${name}`, {
      responseType: 'blob',
    });
  };

  return {
    ...baseFindList<ICrmbLeadArquivoCleanDTO, ICrmbLeadArquivoDTO, ICrmbLeadArquivoFullDTO>(resourceURL),
    ...baseFind<ICrmbLeadArquivoCleanDTO, ICrmbLeadArquivoDTO, ICrmbLeadArquivoFullDTO>(resourceURL),
    ...baseCreate<ICrmbLeadArquivoCleanDTO, ICrmbLeadArquivoDTO, ICrmbLeadArquivoFullDTO>(resourceURL),
    ...baseDelete(resourceURL),
    ...baseUpdate(resourceURL),
    download,
  };

}
